import { render } from "./ConsultTime.vue?vue&type=template&id=187b83df"
import script from "./ConsultTime.vue?vue&type=script&lang=js"
export * from "./ConsultTime.vue?vue&type=script&lang=js"

import "./ConsultTime.vue?vue&type=style&index=0&id=187b83df&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__